<template>
    <div class="side-box">
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('notes')| capitalize}}</div>
            <div>
                <v-icon @click="toggleNotes">mdi-close</v-icon>
            </div>
        </v-layout>
        <div class="side-box-content-note" style="overflow: auto">
            <div class="note-form">
                <v-form @submit.prevent="submit">
                    <v-textarea
                            :label="$t('notes')|capitalize"
                            v-model="note"
                            box
                            :placeholder="$t('notePlaceHolder')"
                            maxlength="720"
                            auto-grow
                            counter
                            v-click-outside="submit"
                            rows="3"
                    ></v-textarea>
                    <v-layout justify-end>
                        <v-btn small color="#4977EE" type="submit" depressed :disabled="!note" class="note-btn mr-0">
                            {{$t('save')|capitalize}}
                        </v-btn>
                    </v-layout>
                </v-form>
            </div>
            <div v-for="(note, i) in customerNotes" :key="i" class="note-form">
                <div v-if="note_editing_index===i" style="height: 100%">
                    <v-textarea
                            :label="$t('notes')|capitalize"
                            v-model="editNote"
                            box
                            :placeholder="$t('notePlaceHolder')"
                            maxlength="720"
                            auto-grow
                            counter
                    ></v-textarea>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="btn-note-edit ml-0" icon small>
                                <v-icon small color="blue" v-on="on" v-on:click="saveNote(i)" :disabled="!editNote">
                                    mdi-content-save
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{$t('save')|capitalize}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="btn-note-delete" icon small>
                                <v-icon small color="red" v-on="on" v-on:click="deleteNote(i)">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>{{$t('delete')|capitalize}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="btn-note-delete" icon small>
                                <v-icon small color="black" v-on="on" @click="note_editing_index=null">mdi-close
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{$t('cancel')|capitalize}}</span>
                    </v-tooltip>
                </div>
                <div class="note-display" @click="editNotes(note,i)" v-else>
                    <span>{{note.note}}</span>

                    <div class="user">
                        <span>{{note.user.email}}</span><span>{{formatDateTime(note.created_time)}}</span>
                    </div>
                </div>
            </div>
        </div>
        <v-layout justify-space-between align-center class="side-box-header-info">
            <div class="side-box-title">{{$t('customerInformation')| capitalize}}</div>
        </v-layout>
        <div class="side-box-content-info" style="overflow: auto">
            <div class="note-form">
                <v-container grid-list-md text-xs-center class="py-2 px-3">
                    <v-layout row wrap class="py-2">
                        <v-flex xs4 class="text-xs-left font-weight-bold" style="border-right: 1px solid rgba(0, 0, 0, 0.1);">
                            <span class="cus-info-label">Join date</span>
                        </v-flex>
                        <v-flex xs7 class="text-xs-left">
                            <span class="cus-info-value">{{customer_extra_fields.join_date | moment("DD/MM/YYYY HH:mm")}}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="py-2">
                        <v-flex xs4 class="text-xs-left font-weight-bold" style="border-right: 1px solid rgba(0, 0, 0, 0.1);">
                            <span class="cus-info-label">Last activate</span>
                        </v-flex>
                        <v-flex xs7 class="text-xs-left">
                            <span class="cus-info-value">{{customer_extra_fields.last_activate | moment("DD/MM/YYYY HH:mm")}}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="py-2">
                        <v-flex xs4 class="text-xs-left font-weight-bold" style="border-right: 1px solid rgba(0, 0, 0, 0.1);">
                            <span class="cus-info-label">Total messages</span>
                        </v-flex>
                        <v-flex xs7 class="text-xs-left">
                            <span class="cus-info-value">{{customer_extra_fields.total_messages}}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-for="(att, index) in customerAttributes" v-bind:key="index" class="py-2">
                        <v-flex xs4 class="text-xs-left font-weight-bold" style="border-right: 1px solid rgba(0, 0, 0, 0.1);">
                            <span class="cus-info-label">{{ att.label }}</span>
                        </v-flex>
                        <v-flex xs7 class="text-xs-left">
                            <input :id="'txt_edit_' + att.label" :ref="'txt_edit_' + att.label" v-if="att.is_edit" v-model="att.value">
                            <span v-else :ref="'span_display_' + att.label" class="cus-info-value">{{ att.value }}</span>
                        </v-flex>
                        <v-flex xs1 style="position: relative;">
                            <v-btn v-if="isAllowEdit && att.can_edit && !editing" icon class="ma-0 btn-edit-info" @click="edit_attribute(att)"><v-icon>mdi-pencil</v-icon></v-btn>
                            <v-btn v-if="isAllowEdit && att.is_edit" icon class="ma-0 btn-save-info" title="Save" @click="save_attribute(att)"><v-icon>mdi-content-save</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>

            </div>
        </div>
    </div>
</template>

<script>
import CustomerService from "@/services/customer.service";
import StaffService from "@/services/staff.service";
import {mapGetters, mapMutations, mapState} from "vuex";

const moment = require('moment');
    export default {
        name: "Notes",
        data() {
            return {
                customerNotes: [],
                note: '',
                editNote: '',
                note_editing_index: null,

                defaultAttributes: ['_id', 'collection_id', 'created', 'updated', 'customer_id'],
                customerAttributeObject: null,
                customerAttributes: [
                    { label: "sender_id", value: "9492test_mem_leak_ws_1-0", can_edit: false},
                    { label: "sender_name", value: "9492test_mem_leak_ws_1-0", can_edit: true, is_edit: false},
                    { label: "sender_name_customer", value: "9492test_mem_leak_ws_1-0 _hsdhf -hsr 443", can_edit: true, is_edit: false},
                ],
                old_value: '',
                editing: false,
                customer_extra_fields: {}
            }
        },
        mounted() {
            let sender_id = this.$route.params.senderId;
            if (sender_id) {
                this.loadNoteOfCustomer();
                this.loadAttributesOfCustomer();
                this.loadCustomerExtraFields();
            }
        },
        directive: {
            "click-outside": {
                bind() {
                    this.event = event => this.vm.$emit(this.expression, event);
                    this.el.addEventListener('click', this.stopProp);
                    document.body.addEventListener('click', this.event)
                },
                unbind() {
                    this.el.removeEventListener('click', this.stopProp);
                    document.body.removeEventListener('click', this.event)
                },

                stopProp(event) {
                    event.stopPropagation()
                }
            }
        },
        computed: {
            ...mapState('config', ['botConfig']),
            ...mapGetters(['isAdminRole']),
            ...mapState(['user']),
            isAllowEdit() {
                if (this.isAdminRole) {
                    return true;
                } else {
                    return this.botConfig['allowSupporterEditCrm'] === "1";
                }
            },
        },
        methods: {
            ...mapMutations('sideBox', [
                'toggleNotes'
            ]),
            formatDateTime(time) {
                return moment(time).format('DD/MM/YYYY HH:mm')
            },
            async submit() {
                if (this.note) {
                    let data_note = [{
                        created_time: new Date(),
                        user: StaffService.getMe(),
                        note: this.note
                    }, ...this.customerNotes];
                    let botCode = this.$route.params.bot_code;
                    let customerId = this.$route.params.senderId;
                    CustomerService.updateCustomerNote(botCode, customerId, data_note).then(
                        (notes) => {
                            this.note = '';
                            this.customerNotes = notes.data
                        },
                        this.$AppService.handleRequestError('can not save note')
                    );
                }

            },
            async loadNoteOfCustomer() {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                CustomerService.getAllCustomerNotes(botCode, customerId).then(
                    notes => {
                        this.customerNotes = notes.data;
                    },
                    this.$AppService.handleRequestError('can not load notes')
                );
            },
            deleteNote(note_index) {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                this.customerNotes.splice(note_index, 1);
                let data_note = [...this.customerNotes];
                CustomerService.updateCustomerNote(botCode, customerId, data_note).then(
                    (notes) => {
                        this.note = '';
                        this.note_editing_index = null;
                        this.customerNotes = notes.data
                    },
                    this.$AppService.handleRequestError('can not save note')
                );
            },
            saveNote(note_index) {
                this.customerNotes[note_index].note = this.editNote;
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                let data_note = [...this.customerNotes];
                CustomerService.updateCustomerNote(botCode, customerId, data_note).then(
                    (notes) => {
                        this.note = '';
                        this.note_editing_index = null;
                        this.customerNotes = notes.data
                    },
                    this.$AppService.handleRequestError('can not save note')
                );
            },
            editNotes(note, id) {
                // check permission edit
                if (this.user.id === note.user.id) {
                    // close all edit note
                    this.note_editing_index = id;
                    this.editNote = note.note
                }
            },
            async loadAttributesOfCustomer() {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                this.customerAttributes = [];
                if (!botCode || !customerId) {
                    return
                }
                CustomerService.getCustomerAttributes(botCode, customerId).then(
                    result_atts => {
                        this.customerAttributeObject = result_atts.data;
                        if (Object.keys(result_atts.data).length > 0) {
                            let _this = this;
                            // collect user built in attributes
                            let lst_keys_built_in = Object.keys(this.customerAttributeObject.built_in);
                            if (lst_keys_built_in.length > 0) {
                                lst_keys_built_in.forEach(k => {
                                    if (_this.defaultAttributes.indexOf(k) < 0) {
                                        let att = {
                                            label: k,
                                            value: this.customerAttributeObject.built_in[k],
                                            can_edit: false
                                        };

                                        this.customerAttributes.push(att);
                                    }
                                });
                            }
                            // collect user normal attributes
                            let lst_keys_atts = Object.keys(this.customerAttributeObject.attributes);
                            if (lst_keys_atts.length > 0) {
                                lst_keys_atts.forEach(k => {
                                    if (_this.defaultAttributes.indexOf(k) < 0) {
                                        let att = {
                                            label: k,
                                            value: this.customerAttributeObject.attributes[k],
                                            can_edit: true
                                        };

                                        this.customerAttributes.push(att);
                                    }
                                });
                            }
                        }
                    },
                    // this.$AppService.handleRequestError('Can not load customer attributes')
                );
            },
            edit_attribute(attribute) {
                attribute.is_edit = true;
                this.editing = true;
                this.old_value = attribute.value;

                this.$nextTick(() => {
                    this.$refs['txt_edit_' + attribute.label][0].focus();
                });
            },
            async save_attribute(attribute) {
                attribute.is_edit = false;
                this.editing = false;
                this.$nextTick(() => {
                    this.$refs['span_display_' + attribute.label][0].setAttribute("class", "cus-info-value updating-content")
                });

                let data_update = {
                    update_attributes: {}
                };

                data_update.update_attributes[attribute.label] = attribute.value;

                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                let _this = this;

                CustomerService.updateCustomerAttributes(botCode, customerId, data_update).then(() => {
                    this.$refs['span_display_' + attribute.label][0].setAttribute("class", "cus-info-value updated-content-success")
                }).catch(() => {
                    attribute.value = _this.old_value;
                    this.$refs['span_display_' + attribute.label][0].setAttribute("class", "cus-info-value updated-content-fail");
                    this.$AppService.handleRequestError('Update customer attributes failed!')
                });
            },
            loadCustomerExtraFields(){
                let botCode = this.$route.params.bot_code;
                let senderId = this.$route.params.senderId;
                CustomerService.getCustomerExtraFields(botCode, senderId)
                    .then((res)=>{
                        this.customer_extra_fields = res.data
                    })
            }
        },
        events: {}
    }
</script>
<style scoped lang="scss">
    @import "../style/side-box";
</style>
<style scoped lang="scss">
    @import "../style/notes";
</style>
